import { render, staticRenderFns } from "./PlatformSelectField.vue?vue&type=template&id=0e0ea7f0&scoped=true"
import script from "./PlatformSelectField.vue?vue&type=script&lang=ts"
export * from "./PlatformSelectField.vue?vue&type=script&lang=ts"
import style0 from "./PlatformSelectField.vue?vue&type=style&index=0&id=0e0ea7f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0ea7f0",
  null
  
)

export default component.exports